/** pdftotext bbox yMax → pdf-lib baseline-ish y (origin bottom-left). */
export function pdfYFromTop(pageHeight: number, yMax: number): number {
  return pageHeight - yMax;
}
